/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

let MaintenanceManage = [
    {
        path: '/maintenanceManage',
        name: 'maintenanceManage',
        component: Layout,
        children: [
            {
                path: 'declareMaintenance',
                name: 'declareMaintenance',
                meta: { title: '运维申报' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-declare-maintenance',
                        meta: { title: '运维申报', key: 'maintenance-manage-declare-maintenance' },
                        component: () => import('src/pages/maintenanceManage/declareMaintenance/declareMaintenance'),
                    },
                    {
                        path: 'audit',
                        name: 'maintenance-manage-audit-maintenance',
                        meta: { title: '运维审核' , key: 'maintenance-manage-audit-maintenance'},
                        component: () => import('src/pages/maintenanceManage/declareMaintenance/declareMaintenance'),
                    },
                ],
            },
            {
                path: 'malfunctionManage',
                name: 'malfunctionManage',
                meta: { title: '故障申报' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-declare-malfunction',
                        meta: { title: '故障申报' , key: 'maintenance-manage-declare-malfunction'},
                        component: () => import('src/pages/maintenanceManage/declareMalfunction/declareMalfunction'),
                    },
                    {
                        path: 'audit',
                        name: 'maintenance-manage-audit-malfunction',
                        meta: { title: '故障审核', key: 'maintenance-manage-audit-malfunction' },
                        component: () => import('src/pages/maintenanceManage/declareMalfunction/declareMalfunction'),
                    },
                    {
                        path: 'submit',
                        name: 'maintenance-manage-submit-malfunction',
                        meta: { title: '故障提交' , key: 'maintenance-manage-submit-malfunction'},
                        component: () => import('src/pages/maintenanceManage/declareMalfunction/declareMalfunction'),
                    },
                ],
            },
            {
                path: 'compareNotice',
                name: 'compareNotice',
                meta: { title: '对比通知' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-compare-notice',
                        meta: { title: '对比通知' },
                        component: () => import('src/pages/maintenanceManage/compareNotice/compareNotice'),
                    },
                ],
            },
            {
                path: 'compareTaskConfirm',
                name: 'compareTaskConfirm',
                meta: { title: '对比任务确认' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-compare-task-confirm',
                        meta: { title: '对比任务确认' , key: 'maintenance-manage-compare-task-confirm'},
                        component: () => import('src/pages/maintenanceManage/compareTaskConfirm/compareTaskConfirm'),
                    },{
                        path: 'deal',
                        name: 'maintenance-manage-compare-task-deal',
                        meta: { title: '对比任务处理' , key: 'maintenance-manage-compare-task-deal'},
                        component: () => import('src/pages/maintenanceManage/compareTaskConfirm/compareTaskConfirm'),
                    },
                ],
            },
            {
                path: 'compareException',
                name: 'compareException',
                meta: { title: '异常通知' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-compare-exception',
                        meta: { title: '异常通知' },
                        component: () => import('src/pages/maintenanceManage/compareException/compareException'),
                    },
                ],
            },
            {
                path: 'exceptionTask',
                name: 'exceptionTask',
                meta: { title: '异常任务' },
                component: Keep,
                children: [
                    {
                        path: 'dispatch',
                        name: 'maintenance-manage-exception-task-dispatch',
                        meta: { title: '异常任务派发', key: 'maintenance-manage-exception-task-dispatch' },
                        component: () => import('src/pages/maintenanceManage/exceptionTask/exceptionTask'),
                    },{
                        path: 'deal',
                        name: 'maintenance-manage-exception-task-deal',
                        meta: { title: '异常任务处理' , key: 'maintenance-manage-exception-task-deal'},
                        component: () => import('src/pages/maintenanceManage/exceptionTask/exceptionTask'),
                    },
                ],
            },
            {
                path: 'maintenanceStatic',
                name: 'maintenanceStatic',
                meta: { title: '运维统计' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-maintenance-static',
                        meta: { title: '运维统计' },
                        component: () => import('src/pages/maintenanceManage/maintenanceStatic/maintenanceStatic'),
                    }
                ],
            },
            {
                path: 'maintenanceRecord',
                name: 'maintenanceRecord',
                meta: { title: '运维记录' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-maintenance-record',
                        meta: { title: '运维记录' },
                        component: () => import('src/pages/maintenanceManage/maintenanceRecord/maintenanceRecord'),
                    }
                ],
            },
            {
                path: 'original',
                name: 'originalMessage',
                meta: { title: '原始报文' },
                component: Keep,
                children: [
                    {
                        path: 'message',
                        name: 'maintenance-manage-original-message',
                        meta: { title: '原始报文' },
                        component: () => import('src/pages/maintenanceManage/originalMessage/originalMessage'),
                    }
                ],
            },
            {
                path: 'software',
                name: 'softwareSecretKey',
                meta: { title: '软件密钥' },
                component: Keep,
                children: [
                    {
                        path: 'secretKey',
                        name: 'maintenance-manage-software-secretKey',
                        meta: { title: '软件密钥' },
                        component: () => import('src/pages/maintenanceManage/softwareSecretKey/softwareSecretKey'),
                    }
                ], 
            },
            {
                path: 'alga',
                name: 'algaPicture',
                meta: { title: '藻类图片' },
                component: Keep,
                children: [
                    {
                        path: 'picture',
                        name: 'maintenance-manage-alga-picture',
                        meta: { title: '藻类图片' },
                        component: () => import('src/pages/maintenanceManage/algaPicture/algaPicture'),
                    }
                ],
            },
            {
                path: 'data',
                name: 'dataButtJoint',
                meta: { title: '数据对接' },
                component: Keep,
                children: [
                    {
                        path: 'buttJoint',
                        name: 'maintenance-manage-data-buttJoint',
                        meta: { title: '数据对接' },
                        component: () => import('src/pages/maintenanceManage/dataButtJoint/dataButtJoint'),
                    }
                ], 
            },
            {
                path: 'solution',
                name: 'solutionKey',
                meta: { title: '解决方案' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-solution-solutionKey',
                        meta: { title: '解决方案' },
                        component: () => import('src/pages/maintenanceManage/solutionKey/solutionKey'),
                        // component: () => import('src/pages/alarmManage/alarmSearch/alarmSearch'),
                    }
                ], 
            },
            {
                path: 'operating',
                name: 'operatingKey',
                meta: { title: '操作记录' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'maintenance-manage-operating-operatingKey',
                        meta: { title: '操作记录' },
                        component: () => import('src/pages/maintenanceManage/operatingKey/operatingKey'),
                        // component: () => import('src/pages/alarmManage/alarmStatistics/alarmStatistics'),
                    }
                ], 
            }
        ],
    },
]

export default MaintenanceManage
